import { approveProductCommissionPending,approveProductCommissionSuccess,approveProductCommissionFail,rejectProductCommissionPending,rejectProductCommissionSuccess,rejectProductCommissionFail,getProductCommissionPending, getProductCommissionSuccess, getProductCommissionFail, 
    deleteProductCommissionPending, deleteProductCommissionSuccess, deleteProductCommissionFail,
    createProductCommissionPending,createProductCommissionSuccess,createProductCommissionFail,getSProductCommissionPending, getSProductCommissionSuccess, getSProductCommissionFail, modifyProductCommissionPending, modifyProductCommissionSuccess, modifyProductCommissionFail } from "./commissionSlice";
import { fetchAllProductCommission, productcommissionDelete,productcommissionApprove,productcommissionReject,productcommissionCreation, productcommissionModify, fetchSingleProductCommission } from "../../../api/userApi";
import Swal from "sweetalert2";
export const getAllProductCommission = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getProductCommissionPending());
        const result = await fetchAllProductCommission();
        //const userData=JSON.parse(result);
        // console.log('productcommississssonData ' + result);
        const myJSON = JSON.stringify(result);

     
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const roledetails = JSON.parse(JSON.stringify(myObj.commissions));
        console.log("inko",roledetails)
        //console.log('us '+roledetails1[0].id);
        //console.log('getuserpending '+result.userroles[0].id);
        /* console.log('getuserpending user '+result.user[0].firstName);
        console.log('getuserpending fname '+result.lastName);
        console.log('getuserpending lname '+result.user.lastName); */
        //console.log('check user profile out if');
        if (roledetails) {
            console.log('check user profile');
            return dispatch(getProductCommissionSuccess(roledetails));
        }
        dispatch(getProductCommissionFail("User is not found"));


    } catch (error) {
      //  console.log(error)
        dispatch(getProductCommissionFail(error));

    }
}


export const productcommissionDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteProductCommissionPending());
        const result = await productcommissionDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteProductCommissionSuccess("ProductCommission deleted"))
        : dispatch(deleteProductCommissionFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteProductCommissionFail(err.msg));
    }
    
}

export const productcommissionApproved = (frmDt) => async(dispatch) => {

    try {
        dispatch(approveProductCommissionPending());
        const result = await productcommissionApprove(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(approveProductCommissionSuccess("ProductCommission approved"))
        : dispatch(approveProductCommissionFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(approveProductCommissionFail(err.msg));
    }
    
}


export const productcommissionRejected = (frmDt) => async(dispatch) => {

    try {
        dispatch(rejectProductCommissionPending());
        const result = await productcommissionReject(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(rejectProductCommissionSuccess("ProductCommission rejected"))
        : dispatch(rejectProductCommissionFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(rejectProductCommissionFail(err.msg));
    }
    
}


export const newProductCommissionCreation = (frmDt) => async (dispatch) => {
    try {
        dispatch(createProductCommissionPending());
        const result = await productcommissionCreation(frmDt);
        console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createProductCommissionSuccess(result.message))
            : dispatch(createProductCommissionFail(result.message));

           // console.log("ProductCommissionCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         console.log(err);
         Swal.fire({
            title: 'Error!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(createProductCommissionFail(err.msg));
    }

}


export const productcommissionModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyProductCommissionPending());
        const result = await productcommissionModify(frmDt);
        result.status === "success"
            ? dispatch(modifyProductCommissionSuccess(result.message))
            : dispatch(modifyProductCommissionFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyProductCommissionFail(err.msg));
    }

}



export const getSingleProductCommission = (id) => async (dispatch) => {
   console.log('act'+id);

   try {
    //call the api
   dispatch(getSProductCommissionPending());
   const result = await fetchSingleProductCommission(id);
  // const userData=JSON.parse(result.user);
//console.log('ProductCommissionData ');
//console.log(result);
//console.log(result.commissions);

//console.log('check user profile out if');
   if(result.commissions[0] && result.commissions[0].id){
   //console.log('check user profile');
       return dispatch(getSProductCommissionSuccess(result.commissions));
   }
   dispatch(getSProductCommissionFail("ProductCommission is not found"));

  
} catch (error) {
   dispatch(getSProductCommissionFail(error));

}
   

}




